module.exports = __webpack_public_path__ + "img/icon-house.67705a39.svg";